/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* `httpResource` is still an experimental feature - NOT PRODUCTION READY
* Generated Angular service for InvoiceResource
* Do not edit this file manually
*/
import { HttpContext, HttpContextToken, HttpHeaders, HttpParams, httpResource, HttpResourceOptions, HttpResourceRef, HttpResourceRequest } from "@angular/common/http";
import { inject, Injectable, Signal } from "@angular/core";
import { BASE_PATH_DEFAULT, CLIENT_CONTEXT_TOKEN_DEFAULT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { GetInvoiceByIdResponse, GetOutgoingInvoicesResponse, GetLastNumberedInvoiceDateResponse, InvoiceStateId, PaymentMethod, GetInvoicesResponse, GetInvoiceAccountingOperationsResponse, GetCustomerInvoicingPreviewResponse } from "../models";

@Injectable({ providedIn: "root" })
export class InvoiceResource {
    private readonly basePath: string = inject(BASE_PATH_DEFAULT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_DEFAULT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'default');
    }

    getInvoiceById(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetInvoiceByIdResponse, unknown> & { defaultValue: NoInfer<GetInvoiceByIdResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetInvoiceByIdResponse>;
    getInvoiceById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetInvoiceByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetInvoiceByIdResponse | undefined>;
    getInvoiceById(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetInvoiceByIdResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetInvoiceByIdResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Invoice/${typeof id === 'function' ? id() : id}`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getOutgoingInvoices(stardDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions: HttpResourceOptions<GetOutgoingInvoicesResponse, unknown> & { defaultValue: NoInfer<GetOutgoingInvoicesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetOutgoingInvoicesResponse>;
    getOutgoingInvoices(stardDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions?: HttpResourceOptions<GetOutgoingInvoicesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetOutgoingInvoicesResponse | undefined>;
    getOutgoingInvoices(stardDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions?: HttpResourceOptions<GetOutgoingInvoicesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetOutgoingInvoicesResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const stardDateValue = typeof stardDate === 'function' ? stardDate() : stardDate;
            if (stardDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, stardDateValue, 'stardDate');
            }
            const endDateValue = typeof endDate === 'function' ? endDate() : endDate;
            if (endDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, endDateValue, 'endDate');
            }
            return {
                url: `${this.basePath}/Invoice/Outgoing`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getLastNumberedInvoiceDate(legalEntityId: Signal<number> | number, resourceOptions: HttpResourceOptions<GetLastNumberedInvoiceDateResponse, unknown> & { defaultValue: NoInfer<GetLastNumberedInvoiceDateResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLastNumberedInvoiceDateResponse>;
    getLastNumberedInvoiceDate(legalEntityId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetLastNumberedInvoiceDateResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLastNumberedInvoiceDateResponse | undefined>;
    getLastNumberedInvoiceDate(legalEntityId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetLastNumberedInvoiceDateResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetLastNumberedInvoiceDateResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const legalEntityIdValue = typeof legalEntityId === 'function' ? legalEntityId() : legalEntityId;
            if (legalEntityIdValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, legalEntityIdValue, 'legalEntityId');
            }
            return {
                url: `${this.basePath}/Invoice/last-numbered-date`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getInvoices(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, customerIds: Signal<Array<number>> | Array<number>, stateNames: Signal<Array<InvoiceStateId>> | Array<InvoiceStateId>, legalEntityIds: Signal<Array<number>> | Array<number>, paymentMethods: Signal<Array<PaymentMethod>> | Array<PaymentMethod>, search: Signal<string | null | undefined> | string | null | undefined, resourceOptions: HttpResourceOptions<GetInvoicesResponse, unknown> & { defaultValue: NoInfer<GetInvoicesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetInvoicesResponse>;
    getInvoices(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, customerIds: Signal<Array<number>> | Array<number>, stateNames: Signal<Array<InvoiceStateId>> | Array<InvoiceStateId>, legalEntityIds: Signal<Array<number>> | Array<number>, paymentMethods: Signal<Array<PaymentMethod>> | Array<PaymentMethod>, search?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetInvoicesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetInvoicesResponse | undefined>;
    getInvoices(startDate: Signal<Date> | Date, endDate: Signal<Date> | Date, customerIds: Signal<Array<number>> | Array<number>, stateNames: Signal<Array<InvoiceStateId>> | Array<InvoiceStateId>, legalEntityIds: Signal<Array<number>> | Array<number>, paymentMethods: Signal<Array<PaymentMethod>> | Array<PaymentMethod>, search?: Signal<string | null | undefined> | string | null, resourceOptions?: HttpResourceOptions<GetInvoicesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetInvoicesResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const startDateValue = typeof startDate === 'function' ? startDate() : startDate;
            if (startDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, startDateValue, 'startDate');
            }
            const endDateValue = typeof endDate === 'function' ? endDate() : endDate;
            if (endDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, endDateValue, 'endDate');
            }
            const searchValue = typeof search === 'function' ? search() : search;
            if (searchValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, searchValue, 'search');
            }
            const customerIdsValue = typeof customerIds === 'function' ? customerIds() : customerIds;
            if (customerIdsValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, customerIdsValue, 'customerIds');
            }
            const stateNamesValue = typeof stateNames === 'function' ? stateNames() : stateNames;
            if (stateNamesValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, stateNamesValue, 'stateNames');
            }
            const legalEntityIdsValue = typeof legalEntityIds === 'function' ? legalEntityIds() : legalEntityIds;
            if (legalEntityIdsValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, legalEntityIdsValue, 'legalEntityIds');
            }
            const paymentMethodsValue = typeof paymentMethods === 'function' ? paymentMethods() : paymentMethods;
            if (paymentMethodsValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, paymentMethodsValue, 'paymentMethods');
            }
            return {
                url: `${this.basePath}/Invoice`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getInvoicesPeppolFile(uuids: Signal<Array<string>> | Array<string>, resourceOptions: HttpResourceOptions<Blob, Blob> & { defaultValue: NoInfer<Blob> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob>;
    getInvoicesPeppolFile(uuids: Signal<Array<string>> | Array<string>, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined>;
    getInvoicesPeppolFile(uuids: Signal<Array<string>> | Array<string>, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined> {
        return httpResource.blob(() => {
            let params = new HttpParams();
            const uuidsValue = typeof uuids === 'function' ? uuids() : uuids;
            if (uuidsValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, uuidsValue, 'uuids');
            }
            return {
                url: `${this.basePath}/Invoice/PeppolFile`,
                method: "GET",
                params,
                responseType: 'blob' as 'blob',
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getInvoicesAttachments(uuids: Signal<Array<string>> | Array<string>, resourceOptions: HttpResourceOptions<Blob, Blob> & { defaultValue: NoInfer<Blob> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob>;
    getInvoicesAttachments(uuids: Signal<Array<string>> | Array<string>, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined>;
    getInvoicesAttachments(uuids: Signal<Array<string>> | Array<string>, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined> {
        return httpResource.blob(() => {
            let params = new HttpParams();
            const uuidsValue = typeof uuids === 'function' ? uuids() : uuids;
            if (uuidsValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, uuidsValue, 'uuids');
            }
            return {
                url: `${this.basePath}/Invoice/Attachments`,
                method: "GET",
                params,
                responseType: 'blob' as 'blob',
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getInvoicePdf(id: Signal<number> | number, resourceOptions: HttpResourceOptions<Blob, Blob> & { defaultValue: NoInfer<Blob> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob>;
    getInvoicePdf(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined>;
    getInvoicePdf(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<Blob, Blob>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<Blob | undefined> {
        return httpResource.blob(() => {
            return {
                url: `${this.basePath}/Invoice/${typeof id === 'function' ? id() : id}/Pdf`,
                method: "GET",
                responseType: 'blob' as 'blob',
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getInvoiceAccountingOperations(id: Signal<number> | number, resourceOptions: HttpResourceOptions<GetInvoiceAccountingOperationsResponse, unknown> & { defaultValue: NoInfer<GetInvoiceAccountingOperationsResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetInvoiceAccountingOperationsResponse>;
    getInvoiceAccountingOperations(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetInvoiceAccountingOperationsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetInvoiceAccountingOperationsResponse | undefined>;
    getInvoiceAccountingOperations(id: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetInvoiceAccountingOperationsResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetInvoiceAccountingOperationsResponse | undefined> {
        return httpResource(() => {
            return {
                url: `${this.basePath}/Invoice/${typeof id === 'function' ? id() : id}/AccountingOperations`,
                method: "GET",
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getIncomingInvoices(stardDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions: HttpResourceOptions<GetInvoicesResponse, unknown> & { defaultValue: NoInfer<GetInvoicesResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetInvoicesResponse>;
    getIncomingInvoices(stardDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions?: HttpResourceOptions<GetInvoicesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetInvoicesResponse | undefined>;
    getIncomingInvoices(stardDate: Signal<Date> | Date, endDate: Signal<Date> | Date, resourceOptions?: HttpResourceOptions<GetInvoicesResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetInvoicesResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const stardDateValue = typeof stardDate === 'function' ? stardDate() : stardDate;
            if (stardDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, stardDateValue, 'stardDate');
            }
            const endDateValue = typeof endDate === 'function' ? endDate() : endDate;
            if (endDateValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, endDateValue, 'endDate');
            }
            return {
                url: `${this.basePath}/Invoice/Incoming`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }

    getCustomerInvoicingPreview(customerId: Signal<number> | number, resourceOptions: HttpResourceOptions<GetCustomerInvoicingPreviewResponse, unknown> & { defaultValue: NoInfer<GetCustomerInvoicingPreviewResponse> }, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerInvoicingPreviewResponse>;
    getCustomerInvoicingPreview(customerId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCustomerInvoicingPreviewResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerInvoicingPreviewResponse | undefined>;
    getCustomerInvoicingPreview(customerId: Signal<number> | number, resourceOptions?: HttpResourceOptions<GetCustomerInvoicingPreviewResponse, unknown>, requestOptions?: Omit<HttpResourceRequest, "method" | "url" | "params">): HttpResourceRef<GetCustomerInvoicingPreviewResponse | undefined> {
        return httpResource(() => {
            let params = new HttpParams();
            const customerIdValue = typeof customerId === 'function' ? customerId() : customerId;
            if (customerIdValue != null) {
                params = HttpParamsBuilder.addToHttpParams(params, customerIdValue, 'customerId');
            }
            return {
                url: `${this.basePath}/Invoice/invoicing-preview`,
                method: "GET",
                params,
                context: this.createContextWithClientId(requestOptions?.context),
                ...requestOptions
            }
        }, resourceOptions);
    }
}
